const langMiscMarketingDashboard = {
	title: {
		tag: 'misc.marketing_dashboard.title',
		fr: "Sienna propose une large gamme de fonds multi classes d'actifs et multi-thématiques",
		en: 'Sienna offers a wide range of multi-asset class and multi-thematic funds',
	},
	btn_discover_solutions: {
		tag: 'misc.marketing_dashboard.btn_discover_solutions',
		fr: 'Découvrir les solutions',
		en: 'Discover solutions',
	},
};

export default langMiscMarketingDashboard;
